import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
axios.defaults.withCredentials = true;

function MemberLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
const [showForgot, setShowForgot] = useState(false);
const [emailReset, setEmailReset] = useState("");




 const handleLogin = async () => {
  try {
    const res = await axios.post("/api/memberLogin.php",
      {
        email,
        password,
      },
      { withCredentials: true }
    );

 if (res.data.success && res.data.member) {
  localStorage.setItem("member", JSON.stringify(res.data.member));
  navigate("/member-portal");
} else {
  localStorage.removeItem("member"); // 🧹 prevent bad data
  alert("Login failed");
}
  } catch (err) {
    console.error(err);
    alert("Error");
  }
};
  return (
  <div className="login-page">

    {/* 🔙 BACK BUTTON */}
    <button
      className="back-btn"
      onClick={() => navigate("/")}
    >
      ← Retour
    </button>

    <div className="login-card">

      <h2 className="login-title">Connexion membre</h2>
      <p className="login-subtitle">Accédez à votre espace</p>

      {/* EMAIL */}
      <div className="input-group">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder=" "
          required
        />
        <label>Email</label>
      </div>

      {/* PASSWORD */}
      <div className="input-group">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder=" "
          required
        />
        <label>Mot de passe</label>
      </div>

      {/* LOGIN */}
      <button onClick={handleLogin} className="login-btn">
        Se connecter
      </button>

      {/* FORGOT PASSWORD */}
      <p
        className="forgot-link"
        onClick={() => setShowForgot(true)}
      >
        Mot de passe oublié ?
      </p>

    </div>

    {/* 🔐 MODAL (UNCHANGED LOGIC) */}
    {showForgot && (
      <div className="modal-overlay">
        <div className="modal">

          <h3>🔐 Réinitialiser mot de passe</h3>

          <input
            type="email"
            placeholder="Votre email"
            value={emailReset}
            onChange={(e) => setEmailReset(e.target.value)}
          />

          <div style={{ marginTop: "15px", display: "flex", gap: "10px" }}>
            <button
              onClick={async () => {
                if (!emailReset) return toast.error("Entrer votre email");

                const toastId = toast.loading("Envoi...");

                try {
                  const formData = new FormData();
                  formData.append("email", emailReset);

                  const res = await axios.post(
                    "/api/forgotPassword.php",
                    formData
                  );

                  if (!res.data.success) {
                    return toast.error(res.data.error || "Erreur", { id: toastId });
                  }

                  toast.success("📧 Email envoyé avec succès", { id: toastId });

                  setShowForgot(false);
                  setEmailReset("");

                } catch (err) {
                  console.error(err);
                  toast.error("Erreur serveur ❌", { id: toastId });
                }
              }}
            >
              Envoyer
            </button>

            <button onClick={() => setShowForgot(false)}>
              Annuler
            </button>
          </div>

        </div>
      </div>
    )}

  </div>
);
}

export default MemberLogin;